import { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Text,
} from "@chakra-ui/react";

const DeactivateModal = ({ isOpen, onClose, onConfirm, data }) => {
    const [isConfirming, setIsConfirming] = useState(false);

    if (!data) return null;

    const isActivating = data?.isActive === false;
    const actionLabel = isActivating ? "Aktiviraj" : "Deaktiviraj";

    const handleConfirm = async () => {
        setIsConfirming(true);
        try {
            await onConfirm();
        } finally {
            setIsConfirming(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{actionLabel}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text>
                        Jeste li sigurni da želite {actionLabel.toLowerCase()} poveznicu <b>{data?.name || "ovu poveznicu"}</b>?
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button
                        colorScheme={isActivating ? "green" : "red"}
                        mr={3}
                        onClick={handleConfirm}
                        isLoading={isConfirming}
                        loadingText={`${actionLabel}...`}
                        isDisabled={isConfirming}
                    >
                        {actionLabel}
                    </Button>
                    <Button onClick={onClose} isDisabled={isConfirming}>Povratak</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeactivateModal;
